define('views/transactions/transaction',[
	'views/_base/baseview',
	'text!views/transactions/transaction.html'
], function(BaseView, Template) {
	'use strict';

	return BaseView.extend({
		className: 'transactions-container',
		tagName: 'li',
		isRender: true,
		template: _.template(Template),
		events: { },
		initialize: function(options) {
			options = options || {};
			
			this.model = options.model;
			this.elementName = options.elementName;
			
			BaseView.prototype.initialize(this);
		},

		render: function() {

			this.$el.html(this.template( {data: this.model }));

			return this;
		},
		loadData: function () { },
		close: function() {}
	});
});

